<h4 style="text-align: center; margin-top: 15px; margin-bottom: 15px">Subsidy Pricing</h4>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstMealSubsidyType"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedMealSubsidyType"
		dataKey="MealSubsidyTypeID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--MealSubsidyTypeCD-->
				<th>
					<p-columnFilter type="text" field="MealSubsidyTypeCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MealSubsidyTypeDesc-->
				<th>
					<p-columnFilter type="text" field="MealSubsidyTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MealCostDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="MealCostDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--UsePctDesc-->
				<th>
					<p-columnFilter field="UsePctDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUsePctDesc
								[ngModel]="value"
								[options]="lstUsePctDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="MealSubsidyTypeCD">Code<p-sortIcon field="MealSubsidyTypeCD"></p-sortIcon></th>
				<th pSortableColumn="MealSubsidyTypeDesc">Description<p-sortIcon field="MealSubsidyTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="MealCostDesc">Meal Cost<p-sortIcon field="MealCostDesc"></p-sortIcon></th>
				<th pSortableColumn="UsePctDesc">Use Percentage<p-sortIcon field="UsePctDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-MealSubsidyType>
			<tr [pSelectableRow]="MealSubsidyType" (dblclick)="onRowDblClick(MealSubsidyType)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ MealSubsidyType[col.field] }}
				</td>

				<td>
					<div class="AmountGrid" *ngIf="MealSubsidyType.UsePct == 1">
						<input class="form-control" min="0" max="100" type="number" [(ngModel)]="MealSubsidyType.MealCostSubsidyPct" />
						<label>%</label>
					</div>

					<div class="AmountGrid" *ngIf="MealSubsidyType.UsePct == 0">
						<label>$</label>
						<input class="form-control" min="0" step="0.1" type="number" [(ngModel)]="MealSubsidyType.MealCostAmount" />
					</div>
				</td>

				<td>
					<select class="form-control" name="UsePct" [(ngModel)]="MealSubsidyType.UsePct" (ngModelChange)="onUsePctChange(MealSubsidyType, $event)">
						<option *ngFor="let r of lstUsePct" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
